import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
// const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'zzfld000001': {
    describe: true, // 描述 _text 添加属性
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'ycate': {
    describe: true,
    title: '品牌(月报分类)',
    type: 'select',
    equation: city,
    dictionary: 'A0016'
  },
  'sale_dun1': {
    title: '销量(吨)'
  },
  'sale_money1': {
    title: '销售额(万元)'
  },
  'sale_dun2': {
    title: '销量(吨)'
  },
  'sale_money2': {
    title: '销售额(万元)'
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/eachSaleCenterBrandReportForms.js